import {GoogleLink} from "../../../_tiny/GoogleLink.tsx";
import React from "react";
import type {DeserializedGridCellParams} from "../../MuiXColumnDefinitions.ts";

export const GoogleLinkWrapper: React.FC<DeserializedGridCellParams> = ({colDef, row, children}) => {
    if (colDef.googleLink) {
        return <GoogleLink type={colDef.googleLink.type} objs={[row]}>
            {children}
        </GoogleLink>
    }
    return children;
}
